module.exports = __webpack_public_path__ + "img/banner-01.59e1d348.jpg";